var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "template1wrapper" }, [
    _c(
      "div",
      { staticClass: "answersWrapper" },
      _vm._l(this.answers, function (answer) {
        return _c(
          "div",
          {
            key: answer.id,
            staticClass: "answerItem",
            class: [
              answer.selected ? "selected" : "",
              answer.disabled ? "disabled" : "",
            ],
            style: _vm.answerStyle,
            attrs: {
              title: answer.text,
              "data-cbt": _vm.getDataCbtValue(answer),
            },
            on: {
              click: function ($event) {
                return _vm.selectAnswer(answer.id)
              },
            },
          },
          [
            _c(
              "div",
              {
                staticClass: "answerImage",
                attrs: { "data-cbt": _vm.getDataCbtValue(answer) },
              },
              [
                _c("div", {
                  staticClass: "answerOverlay",
                  attrs: { "data-cbt": _vm.getDataCbtValue(answer) },
                }),
                _vm._v(" "),
                _c("img", {
                  attrs: {
                    src: _vm.getAnswerImage(answer),
                    alt: "",
                    "data-cbt": _vm.getDataCbtValue(answer),
                  },
                }),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "answerContent" }, [
              _c(
                "div",
                {
                  staticClass: "answerTitle",
                  class: [
                    answer.textColor === "black"
                      ? "ti-text-color-black"
                      : "ti-text-color-white",
                  ],
                  attrs: { "data-cbt": _vm.getDataCbtValue(answer) },
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(answer.title) +
                      "\n                "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass:
                    "answer-button ti-btn mt-16 w-auto px-20 px-lg-50 position-relative",
                  class: [
                    answer.textColor === "black"
                      ? "ti-btn-third bg-transparent"
                      : "ti-btn-ghost",
                  ],
                  attrs: {
                    "aria-label": answer.selected
                      ? _vm.selectedButtonText
                      : _vm.buttonText + " " + answer.title,
                    "data-cbt": _vm.getDataCbtValue(answer),
                  },
                  on: {
                    click: function ($event) {
                      return _vm.selectAnswer(answer.id)
                    },
                  },
                },
                [
                  answer.selected
                    ? _c("img", {
                        staticClass: "answerSelectedIcon mr-8",
                        attrs: {
                          src: _vm.images.checkmark,
                          alt: _vm.selectedButtonText,
                          "data-cbt": _vm.getDataCbtValue(answer),
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "span",
                    { attrs: { "data-cbt": _vm.getDataCbtValue(answer) } },
                    [
                      _vm._v(
                        _vm._s(
                          answer.selected
                            ? _vm.selectedButtonText
                            : _vm.buttonText
                        )
                      ),
                    ]
                  ),
                ]
              ),
            ]),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }